var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/graph"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graph"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.0583 5.79248C17.525 3.98415 16.0167 2.47582 14.2083 1.94248C12.8333 1.54248 11.8833 1.57582 11.225 2.06748C10.4333 2.65915 10.3417 3.72582 10.3417 4.48415V6.55915C10.3417 8.60915 11.275 9.65082 13.1083 9.65082H15.5C16.25 9.65082 17.325 9.55915 17.9167 8.76748C18.425 8.11748 18.4667 7.16748 18.0583 5.79248Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7584 11.133C15.5417 10.883 15.225 10.7413 14.9 10.7413H11.9167C10.45 10.7413 9.25837 9.54964 9.25837 8.08297V5.09964C9.25837 4.77464 9.1167 4.45797 8.8667 4.2413C8.62504 4.02464 8.2917 3.92464 7.97504 3.9663C6.0167 4.2163 4.2167 5.2913 3.0417 6.90797C1.85837 8.53297 1.42504 10.5163 1.80004 12.4996C2.3417 15.3663 4.63337 17.658 7.50837 18.1996C7.9667 18.2913 8.42504 18.333 8.88337 18.333C10.3917 18.333 11.85 17.8663 13.0917 16.958C14.7084 15.783 15.7834 13.983 16.0334 12.0246C16.075 11.6996 15.975 11.3746 15.7584 11.133Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphActive);
export default __webpack_public_path__ + "static/media/graph-active.120ad1022d6e6ebc6ff139ade65d8f3d.svg";
export { ForwardRef as ReactComponent };